/** Headline impact metrics — `value` is the raw number the counter animates to. */

export const impactStats = [
  {
    id: 'companies',
    icon: 'Building2',
    label: 'Companies Served',
    value: 50,
    suffix: '+',
    caption: 'Enterprises across 20+ cities',
  },
  {
    id: 'recycled',
    icon: 'Recycle',
    label: 'E-Waste Recycled',
    value: 50,
    suffix: '+ MT',
    caption: 'Processed with 98.6% landfill diversion',
  },
  {
    id: 'co2',
    icon: 'CloudOff',
    label: 'CO₂ Emissions Saved',
    value: 684,
    suffix: ' MT',
    caption: 'Versus virgin material production',
  },
  {
    id: 'trees',
    icon: 'Trees',
    label: 'Trees Equivalent',
    value: 3120,
    suffix: '+',
    caption: 'Annual sequestration equivalent',
  },
  {
    id: 'certificates',
    icon: 'Award',
    label: 'Certificates Issued',
    value: "30" ,
    suffix: '+',
    caption: 'Recycling & data destruction',
  },
];

/** Secondary proof points used in the About and Why-Us sections. */
export const quickFacts = [
  { label: 'E-Waste recycled', value: '50+ MT' },
  { label: 'Material recovery rate', value: '98.6%' },
  { label: 'Cities covered', value: '40+' },
  { label: 'Repeat client rate', value: '94%' },
];

// /** Company milestones for the About page timeline. */
// export const milestones = [
//   { year: '2013', title: 'Founded in Navi Mumbai', description: 'Started as a 4,000 sq ft collection and segregation unit serving local IT parks.' },
//   { year: '2016', title: 'CPCB authorisation secured', description: 'Licensed as an authorised recycler and commissioned our first mechanical separation line.' },
//   { year: '2018', title: 'ISO certifications achieved', description: 'ISO 9001, 14001 and 45001 certified, formalising quality, environment and safety systems.' },
//   { year: '2020', title: 'Data destruction division', description: 'Launched NIST 800-88 sanitisation and on-site shredding for BFSI and data centre clients.' },
//   { year: '2022', title: 'EPR credit desk', description: 'Dedicated team set up to manage producer obligations end to end under the 2022 rules.' },
//   { year: '2024', title: '40,000 MT milestone', description: 'Crossed 40,000 metric tonnes processed with a 98.6% landfill diversion rate.' },
//   { year: '2026', title: 'Li-ion recovery bay', description: 'Commissioned a dedicated lithium-ion handling and black-mass recovery line.' },
// ];

// /** Leadership cards on the About page. */
// export const leadership = [
//   {
//     name: 'Ananya Raghunathan',
//     role: 'Founder & Chief Executive',
//     bio: 'Two decades in environmental engineering; led the facility through its CPCB authorisation and ISO programmes.',
//   },
//   {
//     name: 'Vikram Shetty',
//     role: 'Head of Operations',
//     bio: 'Runs collection logistics across 20+ cities and owns the 48-hour pickup commitment.',
//   },
//   {
//     name: 'Farida Merchant',
//     role: 'Head of Compliance',
//     bio: 'Former regulatory auditor; oversees Form 6, passbook entries and EPR portal reconciliation.',
//   },
//   {
//     name: 'Rohit Bhandari',
//     role: 'Head of Data Security',
//     bio: 'Designed the serial-level chain-of-custody used for every drive we sanitise or shred.',
//   },
// ];

// /** Facility capability cards. */
// export const capabilities = [
//   { icon: 'Factory', title: '65,000 sq ft facility', description: 'Purpose-built dismantling, shredding and separation lines at Taloja, Navi Mumbai.' },
//   { icon: 'Gauge', title: '18,000 MT annual capacity', description: 'Authorised throughput across all e-waste and battery categories.' },
//   { icon: 'Cctv', title: 'Full CCTV coverage', description: 'Every intake, storage and destruction zone recorded and retained for 180 days.' },
//   { icon: 'Users', title: ' trained personnel', description: 'Crews certified in hazardous handling, PPE protocol and secure asset handling.' },
// ];
